import { useContext } from 'react';
import { ConfirmContext, type ConfirmFn } from '@components/common/ConfirmProvider';

/**
 * `if (!(await confirm({...}))) return;` in front of anything irreversible.
 * Throws when the provider is missing rather than silently resolving, so a
 * guard can never be a no-op that looks like it is working.
 */
export function useConfirm(): ConfirmFn {
  const confirm = useContext(ConfirmContext);

  if (!confirm) {
    throw new Error('useConfirm must be used within ConfirmProvider');
  }

  return confirm;
}
